import api from 'api';

export default function deleteNodeAgent(nodeAgentId: string) {
  return api.delete(`node-agents/${nodeAgentId}`);
}
